import React, { FC, ReactNode } from 'react';
import { Button, Modal as AntdModal } from 'antd';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  width?: number;
  showCloseIcon?: boolean;
  children: ReactNode;
  cancel?: {
    title?: string;
    onClick?: () => void;
  };
  submit?: {
    title?: string;
    onClick?: () => void;
  };
}

export const Modal: FC<IComponentProps> = ({ open, loading, width = 420, showCloseIcon = false, children, cancel, submit }) => {
  const handleCancel = () => {
    if (loading) {
      return;
    }

    cancel?.onClick?.();
  };

  return (
    <AntdModal
      rootClassName="redesign modal"
      width={width}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      closeIcon={showCloseIcon}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          {cancel?.title}
        </Button>,
        <Button key="submit" className="button-sm primary" onClick={submit?.onClick} loading={loading}>
          {submit?.title}
        </Button>,
      ]}
    >
      {children}
    </AntdModal>
  );
};
